import { DISCIPLINES, RECORDS, STUDENT_EDUCATION, StudentServicePath } from "utils/constants";
import permissions from "app/permissions";
import PartialRecord from "./PartialRecord";

export const resources = {
  name: StudentServicePath + RECORDS + "/" + STUDENT_EDUCATION + "/:id/" + DISCIPLINES + "/:disciplineId",
  title: "Частичен студентски картон",
  custom: <PartialRecord />,
  permission: permissions.canPreviewStudentRecords,
  isMenu: false,
};
